import PropTypes from 'prop-types';
import { vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, resetButtonStyle } from '@eti/styles';
import { productIds } from '@eti/products';
import { price as priceUtil } from '@eti/utils';
import CartProduct from '../../../../widgets/cart/components/products/CartProduct';
import { useToggle } from '../../../../common/custom-hooks/toggle';
import { propTypes } from './propTypes';

const cartItemStyles = css`
  position: relative;
`;

const mobileCartTriggerStyles = css`
  color: ${vars.colors.links.default};
  display: block;
  font-size: inherit;
  margin: 8px auto 0;
  ${resetButtonStyle};
  position: relative;
  text-decoration: underline;
  z-index: 1;

  &:hover {
    color: ${vars.colors.links.focus};
  }

  &::after {
    border: 2px solid ${vars.colors.links.default};
    border-radius: 6px;
    content: '';
    height: calc(100% + 10px);
    left: -5px;
    opacity: 0;
    position: absolute;
    top: -5px;
    transition: opacity 0.2s ease-in-out;
    width: calc(100% + 10px);
    z-index: -1;
  }

  &:focus-visible {
    &::after {
      opacity: 1;
    }
  }
`;

const stackStyles = css`
  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const getTitle = (title, numberOfUnits) => (numberOfUnits ? `${numberOfUnits} ${title}` : title);

const PaymentLinkCartItems = ({ products = [], shouldShowAllProducts = false }) => {
  const { t } = useTranslation();
  const { isOpen: isProductsExpanded, handleOpen: handleExpandProducts } =
    useToggle(shouldShowAllProducts);

  const numberOfProductsToDisplay = isProductsExpanded
    ? products.length
    : Math.min(2, products.length);

  return (
    <>
      <div className={stackStyles} data-testid="paymentLinkPage-cart-items">
        {products
          ?.slice(0, numberOfProductsToDisplay)
          .map(({ id, numberOfUnits, title, price, text, travelers }) => (
            <div
              className={cartItemStyles}
              data-testid={`cart-product-${productIds[Number(id)]}`}
              key={`product-${id}`}
            >
              <CartProduct
                id={id}
                price={priceUtil.formatPrice(price)}
                text={text}
                title={getTitle(title, numberOfUnits)}
                travelers={travelers}
              />
            </div>
          ))}
      </div>
      {products.length > 2 && !isProductsExpanded && (
        <button
          className={mobileCartTriggerStyles}
          data-testid="payment-mobile-cart-trigger"
          onClick={handleExpandProducts}
          type="button"
        >
          {t('PaymentLink.ShowMoreInformation.Text')}
        </button>
      )}
    </>
  );
};

PaymentLinkCartItems.propTypes = {
  products: propTypes.products,
  shouldShowAllProducts: PropTypes.bool,
};

export default PaymentLinkCartItems;
